export { default } from './NewUpdateModal';
export { default as NewUpdateModalContainer } from './NewUpdateModalContainer';
